interface MarketCapFilterProps {
  min: string;
  max: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  range: {
    market_cap_min: number;
    market_cap_max: number;
  };
}

export default function MarketCapFilter({ min, max, onChange, range }: MarketCapFilterProps) {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300">
        Market Cap Range (₹)
      </label>
      <div className="flex gap-2">
        <input
          type="number"
          name="market_cap_min"
          value={min}
          onChange={onChange}
          placeholder={`Min (${range.market_cap_min})`}
          min={range.market_cap_min}
          max={range.market_cap_max}
          className="block w-full px-3 py-2 text-sm rounded-lg border border-zinc-300 bg-white text-zinc-900 placeholder:text-zinc-400 dark:border-zinc-700 dark:bg-zinc-900 dark:text-white focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/20"
        />
        <input
          type="number"
          name="market_cap_max"
          value={max}
          onChange={onChange}
          placeholder={`Max (${range.market_cap_max})`}
          min={range.market_cap_min}
          max={range.market_cap_max}
          className="block w-full px-3 py-2 text-sm rounded-lg border border-zinc-300 bg-white text-zinc-900 placeholder:text-zinc-400 dark:border-zinc-700 dark:bg-zinc-900 dark:text-white focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/20"
        />
      </div>
    </div>
  );
} 